import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './TodoAppointmentsEditor.html?raw';
import _StatefulSection from '../../moreCore/UI/_StatefulSection/_StatefulSection';
import _uiFrameMixin from '../../moreCore/UI/Container/uiFrame';
import _GlobalSelectEntityDialogsMixin from '../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import { RefAssociateGroupTodoAppointments, RefVtAddressesTodoAppointments, TodoAppointment, TodoDescriptionTodoAppointments, TodoMemberEvisUser } from "./TodoAppointmentsTypes";
import Edit from '../../moreCore/UI/Edit/Edit';
import HintBox from '../../moreCore/UI/HintBox/HintBox';
import CheckBox from '../../moreCore/UI/CheckBox/CheckBox';
import SelectBox from '../../moreCore/UI/SelectBox/SelectBox';
import lang from 'dojo/_base/lang';
import { SelectEntityDialogTypes } from "../../moreCore/_loadingHelpers/SelectEntityDialog";
import DateInput from '../../moreCore/UI/DateInput/DateInput';
import EntityStore from '../../moreCore/Tools/EntityStore';
import StaticTable from '../../moreCore/UI/StaticTable/StaticTable';
import ExpandableSection from '../../moreCore/UI/Container/ExpandableSection';
import { ExpandableSectionMarkings } from "../../moreCore/UI/Container/ExpandableSectionTypes";
import { TodoForm } from "../_loadingHelpers/TodoList";
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';

class TodoAppointmentsEditor extends compose(_StatefulSection, _uiFrameMixin, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    private sectionTodoDescription: HTMLElement;
    private editTodoDescription: MdsLax<InstanceType<typeof Edit>>;
    private sectionHintboxTodoDescription: HTMLElement;
    private hintboxTodoDescription: MdsLax<InstanceType<typeof HintBox>>;
    private sectionIsInstantly: HTMLElement;
    private checkboxIsInstantly: MdsLax<InstanceType<typeof CheckBox>>;
    //sectionDaysForerun1: HTMLElement;
    //numberInputDaysForerun1: NumberInput;
    //numberInputDaysForerun2: NumberInput;
    private selectBoxTodoStatus: MdsLax<InstanceType<typeof SelectBox>>;
    private dateInputDueDate: MdsLax<InstanceType<typeof DateInput>>;
    private dateInputReminderDate: MdsLax<InstanceType<typeof DateInput>>;

    addressTableContainer;
    associateGroupTableContainer;

    addressStore: MdsLax<InstanceType<typeof EntityStore<TodoMemberEvisUser>>>;
    addressTable: MdsLax<InstanceType<typeof StaticTable>>;
    remindersForExpander: MdsLax<InstanceType<typeof ExpandableSection>>;

    addressRowConfig: StaticTable.RowConfig = {
        attributes: [
            "ref_vt_addresses.gDisp_1",
            "is_active",
            "is_allowed_finishing",
            "ref_todo_status.description"
        ],
        headings: [
            (this as any).translate("General_Label_Address"),
            (this as any).translate("General_Label_IsActive"),
            (this as any).translate("General_Label_IsAllowedFinishing"),
            (this as any).translate("General_Label_TodoStatus")
        ],
        colNamesInternal: [
            "ref_vt_addresses.gDisp_1",
            "is_active",
            "is_allowed_finishing",
            "ref_todo_status.description"
        ],
        bgColors: [
            "",
            "",
            "",
            "ref_todo_status.coloration"
        ],txtColors: [
            "",
            "",
            "",
            "ref_todo_status.coloration"
        ]
    }

    addressTableLayout: StaticTable.Layout = {
        label: "addressTable",
        name: "addressTable",
        rows: [(this as any).addressRowConfig]
    }

    private _addressTableFormatter(cell: StaticTable.StaticTableCell<TodoMemberEvisUser>) {
        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;
        let index = cell.tableRow.rowGroup.rowIndex;

        //switch (colName) {
        //    case "is_active":
        //    case "is_allowed_finishing":
        //        let checkBox = new CheckBox();
        //        checkBox.setValue(value, true);
        //        checkBox.on("change", lang.hitch(this, this._onChangeCheckbox, colName, entity));
        //        checkBox.placeAt(node);
        //        return true;
        //}

        return false;
    }

    associateGroupStore: MdsLax<InstanceType<typeof EntityStore<RefAssociateGroupTodoAppointments>>>;
    associateGroupTable: MdsLax<InstanceType<typeof StaticTable>>;
    associateGroupExpander: MdsLax<InstanceType<typeof ExpandableSection>>;

    associateGroupRowConfig: StaticTable.RowConfig = {
        attributes: [
            "ref_associate_group.$Displayname",
            "ref_todo_status.description"
        ],
        headings: [
            (this as any).translate("TodoAppointments_Label_AssociateGroupStack"),
            (this as any).translate("General_Label_TodoStatus")
        ],
        colNamesInternal: [
            "ref_associate_group.$Displayname",
            "ref_todo_status.description"
        ],
        bgColors: [
            "",
            "ref_todo_status.coloration"
        ]
    }

    associateGroupTableLayout: StaticTable.Layout = {
        label: "associateGroupTable",
        name: "associateGroupTable",
        rows: [(this as any).associateGroupRowConfig]
    }

    private _associateGroupTableFormatter(cell: StaticTable.StaticTableCell<TodoMemberEvisUser>) {
        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;
        let index = cell.tableRow.rowGroup.rowIndex;



        return false;
    }


    private _onChangeCheckbox(type: string, entity: TodoMemberEvisUser, value: boolean) {
        entity[type] = value;
        this.addressStore.changeEntry(entity, true);
    }

    protected afterSetData(): void {
        let isMy = this.getAttributeValue<boolean>("is_my");

        // TODO (haha, wirklich): die LIVA-Todoform irgendwie netter integrieren, vielleicht sogar inline.
        //this.addButton("todoForm", "Todoform", lang.hitch(this, this.openTodoForm), null, null,null, false, "secondary");

        if (isMy) {
            this.hintboxTodoDescription.destroy();
            this.UiModder.domConstruct.destroy(this.sectionHintboxTodoDescription);
            this.checkboxIsInstantly.destroy();
            this.UiModder.domConstruct.destroy(this.sectionIsInstantly);
            //this.numberInputDaysForerun1.destroy();
            //this.UiModder.domConstruct.destroy(this.sectionDaysForerun1);
        } else {
            this.editTodoDescription.destroy();
            this.UiModder.domConstruct.destroy(this.sectionTodoDescription);
        }

        let reminderFor = this.getAttributeValue("EL_vt_todo_member_todo_appointment");
        let userData = reminderFor.filter((element) => { return element.Classname === "todo_member_evis_user" });
        let associateGroupData = reminderFor.filter((element) => { return element.Classname === "todo_member_associate_grouped" });
        let diffDataUser = this.getAttributeValue("diffDataUser");
        let diffDataAssociateGroup = this.getAttributeValue("diffDataAssociateGroup");

        let isInstantly = this.getAttributeValue("is_instantly");
        this._onChangeIsInstantly(isInstantly);


        this.remindersForExpander.setMarking(reminderFor.length > 0 ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
        this.addressStore.setup(userData);
        this.addressStore.setDiffData(diffDataUser);
        this.associateGroupStore.setup(associateGroupData);
        this.associateGroupStore.setDiffData(diffDataAssociateGroup);

        
    }

    setup(data: TodoAppointment): void {
        this.setData(data);
        this.show("dlg", data.$Displayname ? data.$Displayname : this.translate("General_Label_EditTodoAppointment"));
        this.createDefaultButton("ok", lang.hitch(this, this._onClickConfirm));
        this._setupAddressTable();
        this._setupAssociateGroupTable()
    }

    private _setupAddressTable(): void {
        this.addressTable = new StaticTable();
        this.addressTable.setTableLayout(this.addressTableLayout);
        this.addressTable.setFormatter(lang.hitch(this, this._addressTableFormatter));
        this.addressTable.addDefaultRowActionButton("delete");
        //this.addressTable.addDefaultRowActionButton("edit", lang.hitch(this, this._onClickEditTodoEntry));

        this.addressTable.setupFromStore(this.addressStore);

        this.addressTable.setCyAttribute("TodoAppointmentsEditorAddressTable");

        this.addressTable.placeAt(this.addressTableContainer);

        this._setExpanderMarking();
    }

    private _setupAssociateGroupTable(): void {
        this.associateGroupTable = new StaticTable();
        this.associateGroupTable.setTableLayout(this.associateGroupTableLayout);
        this.associateGroupTable.setFormatter(lang.hitch(this, this._associateGroupTableFormatter));
        this.associateGroupTable.addDefaultRowActionButton("delete");
        //this.associateGroupTable.addDefaultRowActionButton("edit", lang.hitch(this, this._onClickEditTodoEntry));
        this.associateGroupTable.setupFromStore(this.associateGroupStore);
        this.associateGroupTable.setCyAttribute("TodoAppointmentsEditorassociateGroupTable");

        this.associateGroupTable.placeAt(this.associateGroupTableContainer);

        this._setExpanderMarking();
    }

    private _onClickEditTodoEntry(rowGroup: StaticTable.StaticTableRowGroup<TodoMemberEvisUser>) {
        
        let entity = rowGroup.entity;

       
    }

    private openTodoForm() {
        let todoForm = new TodoForm();
        let entityData = this.currentData as TodoAppointment;

        if (!entityData || !this.entityId) return;

        let dlg = new GenericDialog();

        dlg.setup({
            content: todoForm,
            buttonPreset: "close",
            header: entityData.c_todo_description,
        });

        todoForm.loadData(this.entityId);
        
    }

    private _onClickConfirm(e): void {
        this.emit("confirmed", this.getCurrentData());
        this.close();
    }

    private _onClickButtonAddressAdd(e): void {
        this._openSED("selectUser", e);
    }

    private _storeHasUser(user: RefVtAddressesTodoAppointments) {
        let completeList = this.addressStore.getCurrentCompleteList();
        for (let address of completeList) {
            if (address?.ref_vt_addresses?.ID === user.ID) return true;
        }
        return false;
    } 

    private _onClickButtonAssociateGroupAdd(e): void {
        let completeList = this.associateGroupStore.getCurrentCompleteList();
        if (completeList.length > 0) {
            this.showToast(this.translate("TodoAppointments_Error_AddAssociateGroup"), "fas fa-exclamation-triangle");
            return;
        }
        this._openSED("selectAssociateGroup", e);
    }

    private _openSED(mode: string, e): void {
        this.loadSelectEntityDialog(e, mode, lang.hitch(this, this._onSEDCallback));
    }

    private _onSEDCallback(mode: string, data: Array<string>, items: Array<SelectEntityDialogTypes.Item<TodoDescriptionTodoAppointments | RefVtAddressesTodoAppointments>>): void {
        switch (mode) {
            case "selectTodoDescription":
                if (items) {
                    this.hintboxTodoDescription.setValue(items[0].entry.data);
                }
                break;
            case "selectUser":
                if (items) {
                    for (let item of items) {
                        let user: RefVtAddressesTodoAppointments = item.entry.data as RefVtAddressesTodoAppointments;
                        if (this._storeHasUser(user)) {
                            this.showToast(this.translate("TodoAppointments_Error_AddUser") + ": " + user.gDisp_1, "fas fa-exclamation-triangle");
                        } else {
                            let newAddress: TodoMemberEvisUser = {
                                $Displayname: "",
                                Classname: "todo_member_evis_user",
                                ClassPrintname: "",
                                ID: "" + Math.random() * 100000000,
                                is_active: true,
                                is_allowed_finishing: false,
                                ref_todo_appointment: this.getAttributeValue("___root"),
                                ref_vt_addresses: item.entry.data as RefVtAddressesTodoAppointments,
                                ref_todo_status: null
                            }
                            this.addressStore.addEntry(newAddress);
                        }
                    }
                }
                break;
            case "selectAssociateGroup":
                if (items) {
                    let newAssociateGroup: RefAssociateGroupTodoAppointments = {
                        $Displayname: "",
                        Classname: "todo_member_associate_grouped",
                        ClassPrintname: "",
                        ID: "" + Math.random() * 100000000,
                        is_active: true,
                        is_allowed_finishing: false,
                        ref_associate_group: items[0].entry.data,
                        ref_todo_appointment: this.getAttributeValue("___root"),
                        ref_todo_status: null,
                        ref_vt_addresses: null
                        
                    }
                    this.associateGroupStore.addEntry(newAssociateGroup);
                }
                break;
        }
    }

    private _onChangeIsInstantly(e) {
        if (e) {
            let today = new Date();
            this.dateInputDueDate.setValue(today);
            this.dateInputReminderDate.setValue(today);
            this.dateInputDueDate.setReadonly(true);
            this.dateInputReminderDate.setReadonly(true);
            //this.numberInputDaysForerun1.setValue(0);
            //this.numberInputDaysForerun2.setValue(0);
            //this.numberInputDaysForerun1.setReadonly(true);
            //this.numberInputDaysForerun2.setReadonly(true);
        } else {
            this.dateInputDueDate.setValue(this.sourceData["due_date"]);
            this.dateInputReminderDate.setValue(this.sourceData["alert_time"]);
            this.dateInputDueDate.setReadonly(false);
            this.dateInputReminderDate.setReadonly(false);
            //this.numberInputDaysForerun1.setValue(this.sourceData["days_forerun_1"]);
            //this.numberInputDaysForerun2.setValue(this.sourceData["days_forerun_2"]);
            //this.numberInputDaysForerun1.setReadonly(false);
            //this.numberInputDaysForerun2.setReadonly(false);
        }
    }

    private _onChangeTodoDescriptionHintbox(e) {
        let description = this.hintboxTodoDescription.getValue().description;
        this.setAttributeValue("c_todo_description", description);
    }

    private _setExpanderMarking(): void {
        
        let completeListAddress = this.addressStore.getCurrentCompleteList();
        let completeListAssociateGroup = this.associateGroupStore.getCurrentCompleteList();

        this.remindersForExpander.setMarking(completeListAddress.length > 0 || completeListAssociateGroup.length > 0
            ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
    }

    private _onChangeStore(type: string): void {
        this._setExpanderMarking();

        switch (type) {
            case "user":
                let diffDataAddress = this.addressStore.getDiffData();
                this.setAttributeValue("diffDataUser", diffDataAddress);
                break;
            case "associateGroup":
                let diffDataAssociateGroup = this.associateGroupStore.getDiffData();
                this.setAttributeValue("diffDataAssociateGroup", diffDataAssociateGroup);
                break;
        }
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.SEDconfigCallfunction = "Webtool_API__TodoAppointments_GetSEDConfig";

        this.hintboxTodoDescription.addInlineButton(lang.hitch(this, this._openSED, "selectTodoDescription"));
        this.checkboxIsInstantly.on("change", lang.hitch(this, this._onChangeIsInstantly));
        this.hintboxTodoDescription.on("change", lang.hitch(this, this._onChangeTodoDescriptionHintbox));

        this.addressStore = new EntityStore();
        this.addressStore.on("change", lang.hitch(this, this._onChangeStore, "user"));

        this.associateGroupStore = new EntityStore();
        this.associateGroupStore.on("change", lang.hitch(this, this._onChangeStore, "associateGroup"))
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(TodoAppointmentsEditor);